import React from "react";
import "./DfySuccess.css";

export default function DfySuccessPage() {
  return (
    <div className="dfy-success-page">
      <div className="dfy-success-card">
        <div className="dfy-success-header">
          <div className="dfy-success-icon">✓</div>
          <div>
            <h1 className="dfy-success-title">You’re in. DFY is live.</h1>
            <p className="dfy-success-subtitle">
              Your Done-For-You weekly insight reports are now active. Check your
              email for a welcome message with next steps.
            </p>
          </div>
        </div>

        <div className="dfy-success-body">
          <p>Here’s what happens next:</p>
          <ul className="dfy-success-steps">
            <li>Look for the welcome email from Taren in the next few minutes.</li>
            <li>Use the secure upload link in the following emails to send your first data file.</li>
            <li>We clean, analyze, and send back your first DFY insight report.</li>
          </ul>
        </div>

        <div className="dfy-success-meta-row">
          <span className="dfy-success-pill">DFY subscription active</span>
          <span className="dfy-success-pill">Welcome email on its way</span>
        </div>

        <div className="dfy-success-actions">
          <a href="/" className="dfy-success-btn-secondary">
            Back to home
          </a>
        </div>

        <p className="dfy-success-helper">
          Not seeing an email? Check your spam folder or promotions tab, or
          contact sam@technologiesgk.com
        </p>
      </div>
    </div>
  );
}
